var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCatStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 112,
    viewBox: "0 0 101 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2205_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4637 0.649414C38.7166 7.50464 55.0109 29.651 55.0109 55.9126C55.0109 74.081 47.2122 90.2797 35.0371 100.808C15.2654 92.0271 1.22266 69.7648 1.22266 43.6888C1.22266 26.9021 7.04235 11.6959 16.4637 0.649414Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8935 8.2373C34.3027 14.4975 46.4538 37.0753 46.4538 63.9684C46.4538 79.4372 42.4336 93.4783 35.8953 103.808C19.4861 97.5472 7.33496 74.9696 7.33496 48.0765C7.33496 32.6076 11.3551 18.5666 17.8935 8.2373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4006 0C61.3976 6.6794 45.2314 28.9575 45.2314 55.4112C45.2314 73.9153 53.1414 90.3765 65.426 100.885C85.0585 92.1575 99.0197 69.841 99.0197 43.6883C99.0197 26.5704 93.0384 11.096 83.4006 0Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1259 7.01465C64.7166 13.2748 52.5654 35.8526 52.5654 62.7459C52.5654 78.2147 56.5856 92.2559 63.1239 102.585C79.5333 96.3249 91.6844 73.7472 91.6844 46.8539C91.6844 31.385 87.6642 17.344 81.1259 7.01465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1209 110.923C77.8019 110.923 100.242 88.4835 100.242 60.8025C100.242 33.1215 77.8019 10.6816 50.1209 10.6816C22.4399 10.6816 0 33.1215 0 60.8025C0 88.4835 22.4399 110.923 50.1209 110.923Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.51 86.4742C62.0003 86.4742 72.1256 76.3489 72.1256 63.8587C72.1256 51.3685 62.0003 41.2432 49.51 41.2432C37.0198 41.2432 26.8945 51.3685 26.8945 63.8587C26.8945 76.3489 37.0198 86.4742 49.51 86.4742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 65.6934L9.08091 67.74C10.1748 67.8549 11.0021 68.7275 11.0021 69.7664C11.0021 70.9816 9.88309 71.9271 8.60387 71.7929L0.789042 69.7664L0 65.6934Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 57.7471L10.7224 62.0771C11.6139 62.3116 12.2246 63.0303 12.2246 63.8454C12.2246 65.0822 10.8636 65.9693 9.51138 65.614L0 62.0257V57.7471Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22256 49.8008L14.8471 57.0884C15.4906 57.4326 15.8921 58.1002 15.8921 58.8261C15.8921 60.3198 14.2866 61.2723 12.9628 60.5642L0.611328 53.4682L1.22256 49.8008Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 65.6934L91.1605 67.74C90.0666 67.8549 89.2393 68.7275 89.2393 69.7664C89.2393 70.9816 90.3583 71.9271 91.6375 71.7929L99.4523 69.7664L100.241 65.6934Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.242 58.3584L89.5197 62.3554C88.6282 62.5717 88.0176 63.2353 88.0176 63.9877C88.0176 65.1292 89.3785 65.9482 90.7308 65.6202L100.242 62.3079V58.3584Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0201 49.8008L85.3537 57.0884C84.736 57.4326 84.3506 58.1002 84.3506 58.8261C84.3506 60.3198 85.8919 61.2723 87.1627 60.5642L99.6313 53.4682L99.0201 49.8008Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8717 60.4298C51.1574 59.4611 52.3409 58.3941 53.4077 57.2416L54.7603 55.2936C55.4881 54.1103 54.557 52.6713 53.0122 52.5924L52.5059 52.5664H48.8997H45.2933L44.7874 52.5924C43.2426 52.6713 42.3115 54.1103 43.0395 55.2936L43.6057 56.1093C44.1289 56.8632 44.7186 57.5807 45.3693 58.2557C46.1258 59.0401 46.9613 59.7638 47.8666 60.4181C45.9402 62.5244 41.7434 63.1287 38.949 63.0396L34.4614 62.3626C33.7943 62.262 33.1611 62.7203 33.0471 63.3864C32.9329 64.0524 33.3812 64.6739 34.0481 64.7745L37.4163 65.2826C38.2153 72.7002 42.6385 79.4605 48.9001 79.4605C55.1303 79.4605 59.0468 72.7676 59.7775 65.3936L63.379 64.6182C64.0385 64.4762 64.4684 63.8234 64.3395 63.1601C64.2105 62.4968 63.5713 62.0742 62.9119 62.2161L59.6222 62.9244C57.104 63.3 52.0041 62.9145 49.8717 60.4298Z",
    fill: "#4D2500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0107 72.1252C55.0107 74.4882 51.9366 75.7926 48.8984 75.7926C45.8603 75.7926 42.7861 74.4882 42.7861 72.1252C42.7861 69.7622 45.8603 67.2354 48.8984 67.2354C51.9366 67.2354 55.0107 69.7622 55.0107 72.1252Z",
    fill: "#FF99B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 28L73.9374 36.2043L83.2658 38.3647L76.9889 45.5957L77.8168 55.1353L69 51.4L60.1832 55.1353L61.0111 45.5957L54.7342 38.3647L64.0626 36.2043L69 28Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28L34.9374 36.2043L44.2658 38.3647L37.9889 45.5957L38.8168 55.1353L30 51.4L21.1832 55.1353L22.0111 45.5957L15.7342 38.3647L25.0626 36.2043L30 28Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2205_2222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.242,
    height: 111.244,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatStar);
export default __webpack_public_path__ + "static/media/cat_star.1eece59fab5570b09ea031be398a197f.svg";
export { ForwardRef as ReactComponent };